// PlanPage.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCurrentUser, getCurrentUser } from "../api/reportApi";

export default function PlanPage() {
    const navigate = useNavigate();
    const [user, setUser] = useState(() => getCurrentUser());
    const [loading, setLoading] = useState(true);
    const [planLoading, setPlanLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        fetchCurrentUser()
            .then(updatedUser => setUser(updatedUser))
            .catch(err => setError(err.message || "Failed to load current plan"))
            .finally(() => setLoading(false));
    }, []);

    const handleCreemCheckout = async plan => {
        if (planLoading) return;

        const token = localStorage.getItem("custor.auth.token");

        if (!token) {
            setError("Your session has expired. Please log in again.");
            return;
        }

        setError("");
        setSuccess("");
        setPlanLoading(true);

        try {
            const response = await fetch("/auth/checkout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ plan })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || data.message || "Failed to create checkout");
            }

            if (!data.url) {
                throw new Error("Creem checkout URL is missing");
            }

            window.location.assign(data.url);
        } catch (err) {
            setError(err.message || "Unable to start checkout");
            setPlanLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="custor-welcome">
                <h1>Subscription</h1>
                <p>Loading current plan...</p>
            </div>
        );
    }

    const currentPlan = user?.plan || "FREE";

    return (
        <div className="custor-welcome" style={{ maxWidth: "900px", margin: "0 auto" }}>
            <h1>Subscription</h1>
            <p>Current plan: <strong>{currentPlan}</strong></p>

            {error && (
                <div className="custor-error">
                    <p>{error}</p>
                </div>
            )}

            {success && <p>{success}</p>}

            {currentPlan === "FREE" && (
                <div>
                    <h2>Choose your plan</h2>
                    <div>
                        <button
                            onClick={() => handleCreemCheckout("PRO")}
                            disabled={planLoading}
                        >
                            {planLoading ? "Processing..." : "Choose PRO"}
                        </button>{" "}
                        <button
                            onClick={() => handleCreemCheckout("ENTERPRISE")}
                            disabled={planLoading}
                        >
                            {planLoading ? "Processing..." : "Choose ENTERPRISE"}
                        </button>
                    </div>
                </div>
            )}

            {currentPlan === "PRO" && (
                <div>
                    <h2>PRO</h2>
                    <p>Your PRO subscription is currently active.</p>
                    <button
                        onClick={() => handleCreemCheckout("ENTERPRISE")}
                        disabled={planLoading}
                    >
                        {planLoading ? "Processing..." : "Upgrade to ENTERPRISE"}
                    </button>
                </div>
            )}

            {currentPlan === "ENTERPRISE" && (
                <div>
                    <h2>ENTERPRISE</h2>
                    <p>Your ENTERPRISE subscription is currently active.</p>
                    <p>You cannot change or renew the plan before the current subscription expires.</p>
                </div>
            )}

            <div style={{ marginTop: "30px" }}>
                <button onClick={() => navigate("/app")} disabled={planLoading}>
                    Back to Custor
                </button>
            </div>
        </div>
    );
}